module.exports = __webpack_public_path__ + "static/media/p-end.8b9673a8.svg";